import React, { useState, useEffect } from 'react';
import { CircleCard } from './circleCard'
import styled from 'styled-components';
import { ListSkeleton } from './skeleton.js'
import { FirebaseRef } from '../../lib/firebase'
import { Button, message } from 'antd';
import './index.scss'
const TABLET_BREAK_POINT = 768;
const MOBILE_BREAK_POINT = 425;

const FeedbackListWrapper = styled.div`
  padding: 20px;
  .list {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    .card {
      list-style: none;
      flex: 0 0 33.333333%;
      padding: 10px;
    }
  }
  @media only screen and (max-width: ${TABLET_BREAK_POINT}px) {
    .list {
      .card {
        flex: 0 0 50%;
      }
    }
  }
  @media only screen and (max-width: ${MOBILE_BREAK_POINT}px) {
    .list {
      .card {
        flex: 0 0 100%;
      }
    }
  }
`;


export default function ManageCircleUser(props) {
  const { member, history } = props
  const [loading, setLoading] = useState(true);

  const [feedbackList, setFeedbackList] = useState([]);
  useEffect(() => {

    let ref = FirebaseRef.child(`/users`)
    ref.on('value', snapshot => {
      const data = snapshot.val()

      let newData = []
      if (data && typeof (data) === 'object') {
        Object.keys(data).forEach(key => {

          if (data[key] && data[key].groupIds && Array.isArray(data[key].groupIds)) {
            const index = data[key].groupIds.findIndex(item => item === member.uid)

            if (index !== -1) {
              newData.push({
                ...data[key],
                id: key,
                uid: key
              })
            }
          }
        })
        newData = [...new Set(newData.reverse())]
        setLoading(false)
      }
      setFeedbackList(newData)

    })
  }, [member.uid]);




  return (
    <FeedbackListWrapper>
      <div className="circle__heading">
        <span>Circle User</span>
        <Button size="large" className="circle__heading-button" type="primary" onClick={() => { history.push("/manage/circle-user/add") }}>Add</Button>
      </div>
      <div className="list">
        {
          !loading
            ?
            feedbackList.map(
              feedback => <div className="card">
                <CircleCard {...props} feedback={feedback} onRemove={(item) => {
                  if (item.groupIds) {
                    item.groupIds = item.groupIds.filter(el => el !== member.uid)
                  }
                  FirebaseRef.child(`users/${item.uid}`).set(item)
                  message.success("Delete user scuccessfully!")
                }} />
              </div>
            )
            :
            <>
              {ListSkeleton()}
            </>
        }
      </div>

    </FeedbackListWrapper>
  )
}